const disableScrollLock = () => {
  // document.body.style.position = ''
  // document.body.style.width = ''
  document.body.style['overflow'] = 'unset'
  document.documentElement.style['overflow'] = 'unset'
  // document.body.style['height'] = ''
}
const enableScrollLock = () => {
  // document.body.style.position = 'fixed'
  // document.body.style.width = '100%'
  document.body.style['overflow'] = 'hidden'
  document.documentElement.style['overflow'] = 'hidden'
  // document.body.style['height'] = '100%'
}

export { disableScrollLock, enableScrollLock }
